export const applicationVariables = {
  serviceName: "Utekirke",
  contactUrl: "https://utekirke.no/om-oss.html",
};

export const questionTypes = {
  simpleText: 'Tekst',
  simpleTextDesc: 'Deltakeren svarer på spørsmålet ved å skrive inn en tekst.',
  multipleChoice: 'Flervalg',
  multipleChoiceDesc: 'Deltakeren får opp flere alternativ der ett av disse er riktig.',
  multipleBothDesc: 'Deltakeren får opp flere alternativ der ett (flervalg) eller mer enn ett (flersvar) av disse er riktig.',
  simpleNumber: 'Tall',
  simpleNumberDesc: 'Svaret på spørsmålet er ett tall. Merk at noen devicer tolker komma som desimalpunkt og andre forventer punktum.',
  practicalAssignment: 'Praktisk',
  practicalAssignmentDesc: 'Deltakeren skal utføre en praktisk oppgave og gi opp ett svar som må tolkes av arrangøren.',
  multipleAnswer: 'Flersvar',
  multipleAnswerDesc: 'Deltakeren får opp flere alternativ der mer en ett av disse er riktig.',
  photoAssignment: 'Kamera',
  photoAssignmentDesc: 'Deltakeren svarer på oppgaven med å ta ett foto.',
  dateSelection: 'Dato',
  boolSelection: 'Ja / Nei',
  unknownType: 'Ugyldig type',
};

export const difficultyOptions = [
  { label: "Annet", value: 30 },
  { label: "0-5 år", value: 1 },
  { label: "6-10 år", value: 2 },
  { label: "11-15 år", value: 3 },
  { label: "15-20 år", value: 4 },
];

// Names below are index dependent
// TODO: Fix index dependent issue
export const questionGroups = {
  name: "Vanskelighetsgrad",
  groups: { difficultyOptions },
};

// Names below are index dependent
// TODO: Fix index dependent issue
export const subjectGroups = {
  name: "Tema",
  subjects: [
    "Annet",
    "Kirkebakkesti",
    "Familie med mindre barn",
    "Temasti",
    "Natur/Klima/Miljø - skaperverket",
    "Pilegrim", "Konfirmant",
    "Skattejakt",
    "Natursti",
    "Omsorg/Felleskap"
  ],
};

export const languages = {
  name: "Målform",
  language: ["Bokmål", "Nynorsk"],
  bokmaal: "bokmål",
  nynorsk: "nynorsk",
};

export const numbers = [
  "ingen", "en", "to", "tre", "fire", "fem", "seks", "syv", "åtte", "ni",
  "ti", "elleve", "tolv", "tretten", "fjorten", "femten", "seksten", "sytten", "atten", "nitten",
  "tyve", "enogtyve", "toogtyve", "treogtyve", "fireogtyve", "femogtyve", "seksogtyve", "syvogtyve", "åtteogtyve", "niogtyve",
  "tredve", "enogtredve", "toogtredve", "treogtredve", "fireogtredve", "femogtredve",
];

export const modalStrings = {
  activateQuestion: "Aktiver sti",
  showGameInfo: "Vis sti",
  startMessage: "Velkommen til stien!",
  finishMessage: "Hurra! Du har fullført stien. Godt jobbet!",
  errorMessage: "Feil ved oppretting av sti",
  howToPlay: "Slik blir du med:",
  useCode: "Be dine deltakere benytte koden:",
  useQr: "Be dine deltakere scanne denne QR koden:",
  areYouSure: "Er du sikker?",
  gameInformationTitle: "Opplysninger",
};

export const gameSettings = {
  settings: "Aktivitetsinnstillinger",
  welcomeMessage: "Velkomstmelding",
  timelimit: "Tidsfrist i minutter",
  noTimelimit: "Ingen tidsfrist",
  showAnswer: "Vis riktige svar etter svart spørsmål",
  showPoints: "Vis poengsum på hvert spørsmål",
  useTimelimit: "Bruk tidsfrister fra hvert spørsmål",
  endMessage: "Avslutningsmelding",
  introHowTo: "Når du har aktivert aktiviteten:",
  howToPlay: "Ber du dine deltakerene skrive inn",
  alternativelyUse: "eller så",
  useUrl: "deler du en lenke de åpner i enheten",
  useQr: "ber du dine deltakerene scanne",
  qrCode: "EN QR-KODE",
  shareUrl: "https://utekirke.web.app/...",
  howToShare: "Alle disse finner du i «Oversikt»-panelet på «Mine stier»-siden etter aktivering.",
  gameCode: "EN AKTIVITETS-KODE",
  numberOfHints: "Antall hint",
  quantityLabel: "Antall",
  allowQrQuestions: "Tillat lesing av andre spørsmål fra QR-kode",
  statusLabelUpdating: "Oppdaterer...",
  statusLabelActivating: "Aktiverer...",
};

export const buttonStrings = {
  activateGame: "Aktiver",
  seeActiveGames: "Se aktive stier",
  newGame: "Ny sti",
  gameLibrary: "Bibliotek",
  deleteGame: "Slett sti",
  deleteTrail: "Slett sti",
  cancel: "Avbryt",
  verifyCreator: "Godkjenn skaper",
  deleteCreator: "Slett skaper",
  saveTitle: "Lagre",
  savingTitle: "Lagrer...",
  loadingTitle: "Laster...",
  uploadingAttachmentTitle: "Laster opp vedlegg...",
  savingQuestion: "Lagrer spørsmål...",
  createQuestion: "Opprett spørsmål",
  creatingQuestion: "Oppretter spørsmål...",
  copyingToLibrary: "Kopier til bibliotek",
  saveAndNew: "Lagre og lag ett til",
  registerNewCreator: "Registrer ny skaper",
  creatingNewCreator: "Oppretter ny skaper...",
  generateRandomPassword: "Lag tilfeldig passord",
};

export const gamesListVariables = {
  gameSearch: "Søk i stier...",
  type: "Type",
  gameName: "Navn",
  date: "Dato",
  posts: "Poster",
  closedTrailsListEmpty: "Du har ingen avslutta stier.",
  trailTemplateListEmpty: "Du har ikke laget noen stier.",
  libraryTemplateListEmpty: "Utekirke-biblioteket er tomt!",
};

export const overviewCardVariables = {
  gameCode: "Aktivitetskode: ",
};

export const scoreboardVariables = {
  gameResults: "Oversikt over stien og resultatene",
  titleOverview: "Oversikt",
  titleQuestions: "Spørsmål",
  titlePhotos: "Bilder",
  titleMapView: "Kart",
  titleResults: "Resultater",
  labelPrint: "Skriv ut",
  labelIncorrect: "Feil svar",
  labelCorrect: "Riktig svar",
  labelMissed: "Noe gikk galt / ikke svart",
};

export const trialVariables = {
  labelWelcome: "Velkommen til Utekirke!",
  labelTrialExpired: "Din prøvetid med Utekirke har gått ut.",
  labelLastDay: "Dette er siste dagen du kan prøve Utekirke.",
  labelFirstDay: "Dette er første dagen du prøver Utekirke.",
  labelDaysRemaining1: "Du har tilgang til Utekirke i ",
  labelDaysRemaining2: " dager til.",
  labelTrialStarted: "Du startet prøvetiden",
  labelGetInContact: "For å få fast tilgang eller hjelp, ta kontakt med",
  labelClose: "Lukk",
};

export const titlesAndDescriptions = {
  allLabel: "Alle",
  otherLabel: "Annet",
  useInNewGame: 'Bruk i ny sti',
  showResults: "Vis resultater",
  descOverview: "Dine aktive og åpne stier",
  answerLabel: "Svar: ",
  correctAnswerLabel: "Riktig svar: ",
  noResponseLabel: "Ikke svart",
  alternativesLabel: "Valg",
  tagsLabel: "Emneknagger",
  tagsHelper: "Skriv inn ny emneknagg",
  noTagsLabel: "Ingen emneknagger",
  selectTagsLabel: "Velg emneknagg",
  participantLabel: "Deltaker",
  imageGalleryLabel: "Bildegalleri",
  topicLabel: "Tema",
  noTopicLabel: "Tema mangler",
  selectTopicLabel: "Velg tema",
  informationLabel: "Opplysninger",
  firstNameLabel: "Fornavn",
  enterFirstNameLabel: "Fyll inn fornavn",
  lastNameLabel: "Etternavn",
  enterLastNameLabel: "Fyll inn etternavn",
  emailAddressLabel: "Epostadresse",
  enterEmailAddressLabel: "Fyll inn epostadresse",
  organisationLabel: "Organisasjon",
  enterOrganisationLabel: "Fyll inn organisasjon",
  superAdminCheckbox: "Super-administrator?",
  creatorHasLicense: "Vedkommende har lisens",
  userHasLicense: "Har lisens for Utekirke",
  temporaryPasswordLabel: "Midlertidlig passord",
  temporaryPasswordHelper: "Fyll inn passord",
  manyLabel: "mange",
  useGameLabel: "Bruk sti",
  gameTypeLabel: "Type sti",
  gameNameLabel: "Navn",
  difficultyLabel: "Vanskelighetsgrad",
  selectDifficultyLabel: "Velg vanskelighetsgrad",
  usedQuestionsLabel: "Spørsmål på stien",
  useCoords: "Bruk eksisterende koordinater",
  copyTitle: 'Vil du bruke koordinater fra stien?',
  copyConfirm: 'Ja',
  copyReject: 'Nei',
  filterName: "Filter",
  searchQuestionsLabel: "Søk i spørsmål...",
  myQuestionsLabel: "Mine spørsmål",
  newQuestionLabel: "Nytt spørsmål",
  editQuestionLabel: "Rediger spørsmål",
  startingUploadLabel: "Starter opplasting...",
  pausedUploadLabel: "Opplasting satt på pause.",
  uploadInProgressLabel: "Opplasting pågår...",
  uploadCompleteLabel: "Opplasting ferdig!",
};

export const editQuestionVariables = {
  labelQuestionType: "Type spørsmål *",
  labelYourQuestion: "Ditt spørsmål *",
  helperYourQuestion: "Skriv inn ditt spørsmål her...",
  labelQuestionHint: "Hint:",
  labelUploadImage: "Last opp bilde",
  labelRecommendedImageSize: "Anbefalt størrelse er 500x500 piksler",
  labelUploadedImage: "Opplastet bilde",
  labelImagePreview: "Forhåndsvisning",
  labelAnswerSection: "Svar *",
  labelTimeLimitsCategories: "Tidsfrist og kategorier",
  labelPointsForQuestion: "Antall poeng",
  labelTimeLimit: "Spørsmålet har tidsfrist",
  labelMinutes: "Min",
  labelSeconds: "Sek",
  labelDifficulty: "Vanskelighetsgrad *",
  helperSelectDifficulty: "Velg vanskelighetsgrad",
  labelTopic: "Velg tema *",
  helperSelectTopic: "Velg tema",
  labelAlternative: "Alt ",
  labelAnswer: "Svar ",
  helperAnswerToQuestion: "Skriv inn svaret på spørsmålet",
  labelMarginOfError: "Feilmargin",
  helperMarginOfError: "± verdi. Null eller tomt felt for nøyaktig svar.",
  labelMinimum: "Min",
  helperMinimum: "Minste verdi",
  labelMaximum: "Maks",
  helperMaximum: "Største verdi",
  labelLanguageSelection: "Velg målform",
  labelCopyToLibrary: "Kopier spørsmål til bibliotek",

};

export const creatorStrings = {
  dateFormat: "Do MMM YYYY",
  labelHeadingCreators: "Skapere",
  labelNewCreator: "Ny skaper",
  labelSearchCreators: "Søk blandt skapere...",
  labelHeaderName: "Navn",
  labelHeaderEmail: "Epostadresse",
  labelHeaderOrganisation: "Organisasjon",
  labelHeaderRegistered: "Registrert",
  labelHeaderLogins: "Pålogginger",
  labelHeaderLastSeen: "Sist sett",
  labelHeaderSuperAdmin: "SuperAdmin?",
  labelHeaderTrialPeriod: "Prøvetid",
  labelNoCreatorsFound: "Ingen skapere å vise.",
  labelNewCreatorTitle: "Registrer ny skaper",
  labelVerified: "Godkjent",
  labelMissingStartDate: "Mangler startdato",
  labelTrialOvertime: "Overtid: ",
  labelTrialRemaining: "Gjenstår: ",
  labelDay: " dag",
  labelDays: " dager",
  labelUnknown: "Ukjent",
  labelNever: "aldri",
  labelYes: "Ja",
  labelNo: "Nei",
  tooltipDelete: "Slett",
  tooltipEnableAccess: "Aktiver tilgang",
  tooltipDisableAccess: "Frys tilgang",
  tooltipEdit: "Rediger",
  tooltipExtendTrial: "Forleng prøvetiden",
  tooltipVerify: "Godkjenn skaper",
  labelConfirmVerification: "Er du sikker på at du vil godkjenne",
  labelDeleteParticipant: "Slett deltaker",
  labelDeleteCreator: "Er du sikker på at du vil slette skaperen? (Det kan ta noen minutter.)",
};

export const navSidebarTitles = {
  titleNewTemplate: "Ny sti",
  titleOverview: "Aktive stier",
  titleCreatorTemplates: "Mine stier",
  titleUtekirkeTemplates: "Utekirkebibliotek",
  titleQuestionLibrary: "Spørsmål",
  titleClosedTrails: "Avslutta stier",
};

export const alertMessages = {
  confirmExitPage: "Er du sikker på at du vil gå tilbake?\nDette vil slette alle ulagrede endringer!",
  confirmDeleteTag: "Er du sikker på at du vil sletta emneknaggen",
  functionBlockedExpiredTrial: "Du kan ikke aktivere stien fordi prøvetiden din er gått ut. Vennligst ta kontakt med Utekirke.",
  updateBlockedExpiredTrial: "Du kan ikke oppdatere stien fordi prøvetiden din er gått ut. Vennligst ta kontakt med Utekirke.",
  successProfileUpdated: "Dine opplysinger er oppdatert!",
  errorAnswerFormat: "Feil ved formattering av svar.",
  errorCorrectMissing: "Feil: Ikke mulig å velge riktig svar fra alternativene",
  errorNoMatchingAlternative: "Feil: Kun ett alternativ og ingen svar som hører til",
  errorDataNotFound: "Feil: Data ikke funnet",
  errorQuestionDeleted: "Feil: Spørsmålet ser ut til å være sletta.",
  errorUnexpectedFailure: "Uventet feil ved innlasting av data.",
  errorUnexpectedFailureUpload: "Uventet feil oppstod ved opplasting av data.",
  errorDataUpdateFailure: "Feil ved oppdatering av data.",
  errorFailedToLoadTrail: "Kunne ikke laste inn den valgte stien.",
  errorFailedToLoadQuestion: "Kunne ikke laste inn spørsmålet.",
  errorFailedToLoadLibrary: "Kunne ikke laste inn spørsmål fra biblioteket.",
  errorFailedGettingMediaUrl: "Feil ved henting av URL-en til medieinnholdet.",
  errorEditingQuestion: "Det har skjedd en feil under redigering av spørsmål.",
  errorUpdatingQuestion: "Det har skjedd en feil under oppdatering av spørsmål.",
  errorRegisteringCreator: "Feil ved lagring av ny skaper. Vennligst prøv igjen senere.",
  failedToCreateTrail: "Feil ved oppretting av sti.",
  failedToUpdateTrail: "Feil ved oppdatering av sti.",
  failedToLoadTrails: "Feil ved innlasting av stier.",
  failedToFindQuestion: "Feil: Spørsmålet mangler innhold!",
  failedNoAccess: "Du har ikke tilgang til dette.",
  failedInterrupted: "Avbrutt",
  failedUpload: "Opplasting ikke fullført.",
  validationMissingFirstName: "Vennligst fyll ut fornavn.",
  validationMissingLastName: "Vennligst fyll ut etternavn.",
  validationMissingOrganisation: "Vennligst fyll ut organisasjon.",
  validationWelcomeMessage: "Velkomstmeldinga er ikke gyldig",
  validationFinishMessage: "Avslutningsmeldinga er ikke gyldig",
  validationTimeLimit: "Tidsfristen er ikke gyldig",
  validationBadQuestionFormat: "Spørsmålet er ikke formattert riktig",
  validationBadHintFormat: "Hintet er ikke formattert riktig",
  validationBadAnswerFormat: "Svaret er ikke formattert riktig",
  validationNoValidType: "Ingen gyldig spørsmålstype valgt",
  validationNoQuestionsAdded: "Kan ikke lagre: Du har ikke lagt til noen spørsmål.",
  validationNoLocationsAdded: "Kan ikke lagre: Du har ikke lagt inn noen poster på kartet.",
  validationNoNameGiven: "Kan ikke lagre: Du har ikke gitt stien noe navn.",
  validationRadiusOutOfRange: "Kan ikke lagre: Radiusen du har valgt er ikke gyldig.",
  validationBadFormat: " er ikke formattert riktig",
  validationNoCorrectAnswer: "Ingen svar er markert som riktig!",
  validationIdenticalOptions: "Noen av alternativene eller svarene er identiske",
  validationInvalidAnswer: "Svaret har ikke gydlig format",
  validationMinLessThanMax: "Minimumsverdien kan ikke være større enn maksimumsverdien",
  validationPointsInvalid: "Poengsummen er ikke ett gyldig nummer",
  validationDifficultyNotSelected: "Vanskelighetsgrad er ikke valgt",
  validationDifficultyInvalid: "Noe gikk feil ved valg av vanskelighetsgrad",
  validationTopicNotSelected: "Spørsmålstema er ikke valgt",
  validationTimeLimitMissing: "Når tidsfrist er valgt må antall sekunder også velges",
  validationLanguageNotSelected: "Målform er ikke valgt",
  validationFillInAllFields: "Vennligst fyll ut alle felt.",
};

export const TRIAL_ENABLED = true;
export const TRIAL_DAYS = 14;

export const QUESTION_TEXT_MAX = 500;
export const QUESTION_HINT_MAX = 200;
export const QUESTION_ALTV_MAX = 140;
